import { gql } from '@apollo/client';
import {
  IN_BOUND_INFORMATION_FRAGMENT,
  OUT_BOUND_INFORMATION_FRAGMENT,
} from '../fragments/shippingInformationFragment';

const UPDATE_RMA_TICKET_MUTATION = gql`
  mutation updateRmaTicket($input: UpdateRmaTicketInput!) {
    updateRmaTicket(input: $input) {
      isSuccess
      message
      rmaTicket {
        id
        rmaId
        senderInformation {
          ...InboundInformationFragment
        }
        recipientInformation {
          ...OutboundInformationFragment
        }
        clinicNotes
        facility {
          id
          name
        }
        requestedAt
        status
        notificationEmail
      }
    }
  }

  ${OUT_BOUND_INFORMATION_FRAGMENT}
  ${IN_BOUND_INFORMATION_FRAGMENT}
`;

export default UPDATE_RMA_TICKET_MUTATION;
